// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".check-box[data-v-7fcda07d] {\n  padding: 0 20px;\n}\n[data-v-7fcda07d] .el-scrollbar {\n  height: 280px;\n}\n[data-v-7fcda07d] .el-scrollbar .el-select-dropdown__wrap {\n  max-height: 280px;\n  overflow: hidden;\n}\n[data-v-7fcda07d] .el-scrollbar .el-select-dropdown__wrap .el-select-dropdown__list {\n  padding: 0;\n}\n.option-style[data-v-7fcda07d] {\n  height: 280px;\n  padding: 0 0 10px 0 !important;\n  margin: 0;\n  overflow-y: auto;\n  cursor: default !important;\n}", ""]);
// Exports
module.exports = exports;
